export enum rolesEnum {
  Admin = 'Administrator',
  Agent = 'Agent',
}
